"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecPromotionImpression = void 0;
const enums_1 = require("../enums");
const trackEecPromotion_1 = require("./trackEecPromotion");
function trackEecPromotionImpression(promotions, data) {
    (0, trackEecPromotion_1.trackEecPromotion)(enums_1.EventName.EECPromotionImpression, enums_1.GA4EventName.ViewPromotion, promotions, data);
}
exports.trackEecPromotionImpression = trackEecPromotionImpression;
//# sourceMappingURL=trackEecPromotionImpression.js.map